import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

export default function GraficoNasInicialFinal({ dados }) {
  const labels = dados ? dados.map(d => d.ano) : [];
  const nasInicial = dados ? dados.map(d => d.inicial) : [];
  const nasFinal = dados ? dados.map(d => d.final) : [];

  const data = {
    labels,
    datasets: [
      {
        type: 'bar',
        label: '',
        data: nasInicial,
        backgroundColor: '#E66C37', // gray-400
        borderColor: '#E66C37',
        borderWidth: 1,
      },
      {
        type: 'bar',
        label: '',
        data: nasFinal,
        backgroundColor: '#2DC96F', // blue-900
        borderColor: '#2DC96F',
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: 'NAS Inicial x NAS Final',
        font: { size: 16 },
        padding: { bottom: 20 }
      },
      datalabels: {
        display: false // Ocultar datalabels nesse gráfico para não poluir
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: '' //'Grau NAS'
        }
      }
    }
  };

  return (
    <div className="bg-white p-4 shadow-sm rounded-lg h-80 flex flex-col items-center justify-center">
      {dados && dados.length > 0 ? (
        <Bar data={data} options={options} />
      ) : (
        <p className="text-gray-400">Sem dados para exibir - NAS Inicial x NAS Final</p>
      )}
    </div>
  );
}
